import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import MapThumb from "./MapThumb";

export type MatchOutcome = "win" | "loss" | "draw" | "pending" | "cancelled";

const Row = styled.li`
  position: relative;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 4px 16px;
  min-height: 68px;
  padding: 10px 16px;
  border-radius: 12px;
  transition: background ${(p) => p.theme.motion.fast};
  &:hover,
  &:focus-within {
    background: ${(p) => p.theme.colors.raised};
  }
  .name {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
  }
  &&& .name {
    color: ${(p) => p.theme.colors.text};
  }
  .name::after {
    content: "";
    position: absolute;
    inset: 0;
  }
  .date {
    font-size: 13px;
    line-height: 18px;
    color: ${(p) => p.theme.colors.textMuted};
  }
  .score {
    min-width: 5ch;
    text-align: right;
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    letter-spacing: -0.02em;
    font-variant-numeric: tabular-nums;
  }
  @media (max-width: 560px) {
    grid-template-columns: auto minmax(0, 1fr) auto;
    padding: 10px 8px;
    .state {
      grid-column: 3;
      grid-row: 1;
      justify-self: end;
    }
    .score {
      grid-column: 3;
      grid-row: 2;
      font-size: 16px;
      line-height: 20px;
    }
  }
`;
const State = styled.span<{ $kind: MatchOutcome }>`
  font-size: 14px;
  font-weight: 650;
  color: ${(p) =>
    p.$kind === "win"
      ? p.theme.colors.success
      : p.$kind === "loss"
        ? p.theme.colors.danger
        : p.$kind === "pending"
          ? p.theme.colors.info
          : p.theme.colors.textSecondary};
`;

/**
 * Строка матча: миниатюра карты → название и дата → исход/этап → счёт → переход.
 * Исход и счёт вычисляются вызывающим кодом; компонент ничего не выводит по цвету.
 */
export default function MatchRow({
  to,
  map,
  title,
  date,
  stateLabel,
  outcome,
  score,
}: {
  to: string;
  map?: string | null;
  title: string;
  date: string;
  stateLabel: string;
  outcome: MatchOutcome;
  /** null — счёта нет (идёт или карта не выбрана); «0 : 0» не рисуем. */
  score: [number, number] | null;
}) {
  return (
    <Row>
      <MapThumb map={map} />
      <div style={{ minWidth: 0 }}>
        <Link className="name" to={to}>
          {title}
        </Link>
        <span className="date">{date}</span>
      </div>
      <State className="state" $kind={outcome}>
        {stateLabel}
      </State>
      <span className="score">{score ? `${score[0]} : ${score[1]}` : ""}</span>
    </Row>
  );
}
